export default "__VITE_ASSET__St4LleuQ__"